import { useTranslation } from "react-i18next";
import { useSettings } from "context/SettingsContext"
import UserNameItem from "../Users/UsersRowItems/UserNameItem";
import { Table } from "react-bootstrap";
import { DateTime as DT } from "luxon";
 
const OffRateHistory = () =>{ 
    const { localSettings } = useSettings();
    const { t } = useTranslation(['Rate']);
    let prevRate = 0;
    return (  
        <div className="crm-table-wrap">
            <Table className="RateTable table-hover" > 
                <thead>
                    <tr className="bg-light">
                        <td className="head-user">{t('rateUser')}</td>
                        <td className="head-date">{t('rateDate')}</td>
                        <td className="head-rate">{t('rateValue')}</td>
                    </tr>
                </thead>
                <tbody>
                    {localSettings?.RATE?.history?.map((rate,index)=>{
                            const dt = DT.fromMillis(rate?.dt||0);
                            const curr = rate?.rate||0;
                            const yest = localSettings?.RATE?.history?.[index+1]?.rate||null;
                            const dynamics = yest ? ((curr - yest) / yest) * 100 : '';
                            const rowJsx = (<tr key={rate.dt}>
                                <td className="user">
                                    <UserNameItem 
                                        user={rate}/>
                                </td>
                                <td className="date">
                                    <span className="d-block font-medium">{dt.toLocaleString(DT.DATE_MED)}</span>
                                    <span className="text-muted">{dt.toLocaleString(DT.TIME_SIMPLE)}</span>
                                </td>
                                <td className="rate">
                                    <span className="d-block font-medium">{curr.toFixed(2)}</span>
                                    <span className={`fs-12 font-medium ${dynamics>0 ? 'text-danger' : 'text-success'}`}>
                                        {dynamics>0 ? `+${(dynamics||0).toFixed(2)}` : (dynamics||0).toFixed(2)}
                                    </span> 
                                </td>
                            </tr>);
                            return rowJsx;
                        })
                    }
                </tbody>
            </Table>
        </div>
    )
}

export default OffRateHistory;